import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlocks = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1442_6805)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M10.5 3C10.5 2.80109 10.579 2.61032 10.7197 2.46967C10.8603 2.32902 11.0511 2.25 11.25 2.25H15C15.1989 2.25 15.3897 2.32902 15.5303 2.46967C15.671 2.61032 15.75 2.80109 15.75 3V6.75C15.75 6.94891 15.671 7.13968 15.5303 7.28033C15.3897 7.42098 15.1989 7.5 15 7.5H11.25C11.0511 7.5 10.8603 7.42098 10.7197 7.28033C10.579 7.13968 10.5 6.94891 10.5 6.75V3Z",
			stroke: "#ADB5BD",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M2.25 10.5H11.25C11.6478 10.5 12.0294 10.658 12.3107 10.9393C12.592 11.2206 12.75 11.6022 12.75 12V14.25C12.75 14.6478 12.592 15.0294 12.3107 15.3107C12.0294 15.592 11.6478 15.75 11.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V6.75C2.25 6.35218 2.40804 5.97064 2.68934 5.68934C2.97064 5.40804 3.35218 5.25 3.75 5.25H6C6.39782 5.25 6.77936 5.40804 7.06066 5.68934C7.34196 5.97064 7.5 6.35218 7.5 6.75V15.75",
			stroke: "#ADB5BD",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1442_6805",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgBlocks;
